import {StatusPageContext} from 'context/StatusPage.context'
import {useContext} from 'react'

export const useStatusPage = () => {
  const context = useContext(StatusPageContext)

  if (!context) {
    throw Error('useStatusPage must be used within a StatusPageProvider')
  }
  return context
}
